import {
  NOTIFICATIONS_SUCCESS,
  NOTIFICATIONS_DETAIL_SUCCESS,
  NOTIFICATIONS_TC_SUCCESS
} from './_action'


export function homeReducer(state = {
    campaigns: null,
    user: null,
    popup: {},
  }, action){
    switch(action.type){
      case 'GET_CAMPAIGNS_DASHBOARD_FULFILLED':
        return Object.assign({}, state, {
          campaigns: action.payload.data.results.data,
        })
      case 'GET_USER_DETAIL_FULFILLED':
        return Object.assign({}, state, {
          user: action.payload.data.results,
        })
      case 'GET_USER_DETAIL_REJECTED': {
          if(action.payload.response.status === 401){
            window.location.href="/login"
          }
      }
      case NOTIFICATIONS_SUCCESS:
        console.log(action.data.popup)
          return Object.assign({}, state, {
              popup:action.data.popup || {},
          })
      case NOTIFICATIONS_TC_SUCCESS:
          return Object.assign({}, state, {
              popup:action.popup || {},
          })  
      default:
        return state
    }
  }